import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService } from '../../../../../services'
import { PrintDialog } from '../../../../partials/layout/dialogs/print-dialog/print-dialog.component'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'dossier-personne'

@Component({
  selector: 'atyl-dossier-personne',
  templateUrl: './dossier-personne.component.html',
  styleUrls: ['./dossier-personne.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-personne',
  key: KEY,
})
export class DossierPeronneComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  @Output() changed = new EventEmitter<any>();
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() user: any

  activeButton:boolean=false;

  forms:any[]=[];

  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
	  
	  this.loading.subscribe((dossier)=>{
			  if (dossier) {
				  console.log("personne dossier change ",dossier);
				this.dossier=dossier;
				this.loadForm();
				}
		 });
	  
	 	
     // this.loadForm();
    
  }
  
   loadForm() {
	    let _opts ={
		  typespecial:-1,
          getAll:true
		  
	  }
	  let id:any=(this.dossier.dossierID!=undefined) ? this.dossier.dossierID: this.dossier.ID;
	  
      this.dossierService.getformulairelist(id,_opts).subscribe(
				(res: JSONRpcResponse) => {
				console.log("DossierPeronneComponent ngOnInit",res);
				
				this.forms=this.setObjectUserRights(res.result,"formulaire");
				this.activeButton= (this.forms.length>0);
				
			    this.detectChanges();
			}
		);		
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
  
   print(event: any, formulaire: any) {
        this.dialogService.open(PrintDialog, {
            data: {
                formulaire: formulaire,
                dossier: this.dossier,
                
            },
            draggable: false,
            resizable: false,
        })
        
    }
    
    formulaireSelected(formulaire: any) {
		

		this.popupFormulaire(formulaire)
	}
	
	popupFormulaire(formulaire: any) {
		console.log('popupFormulaire',formulaire)
		let form = formulaire.form
		let demandeForm = formulaire
		let dialogRef:any;
		
		if (form && form.under_form && form.under_form.length === 0) {
			let datasF = {
                    title: form.libelle,
                    id: demandeForm.ID,
                    formType: demandeForm.key,
                    idDemandeForm: form.ID,
                    
                }
           datasF['dossier'] = this.dossier
           datasF['isEditable'] = true;
           if (formulaire.isEditable!=undefined)
           	datasF['isEditable'] = formulaire.isEditable;
              
			if (formulaire.instruction)
			     datasF['instruction'] = formulaire.instruction
			console.log("popupFormulaire FormDialogFormulaireWithSFComponent",datasF,formulaire)     
			dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				//data: formulaire,
				data: datasF,
				height: '90vh',
				width: "90vw",
				resizable: true,
				minimizable: true,
				draggable: true,
				maximizable: true,
			})
		}
		else if (form && form.under_form && form.under_form.length > 0) {
			let form = formulaire.form
			let demandeForm = formulaire.demandeFormulaire
			/*if (form && form.under_form && form.under_form.length === 0) {
				this.dialogService.open(FormDialogFormulaireComponent, {
					data: formulaire,
					height: '90vh',
					width: '80vw',
					resizable: true,
					minimizable: true,
					maximizable: true,
					draggable: true,
				}, (result: any) => {
					this.loadingFormulaire = false
				})
			} else if (form && form.under_form && form.under_form.length > 0) {
             */   
				let datasF = {
					title: form.libelle,
					id: demandeForm.ID,
					formType: demandeForm.key,
					idDemandeForm: form.ID,
				}
				datasF['dossier'] = this.dossier
				 datasF['isEditable'] = true;
	           if (formulaire.isEditable!=undefined)
	           	datasF['isEditable'] = formulaire.isEditable;
				dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
					data: datasF,
					height: '90vh',
					width: "90vw",
					resizable: true,
					minimizable: true,
					draggable: true,
					maximizable: true,
				})


			//}
		}
		
		if (dialogRef) {
		 dialogRef.componentInstance.submited.subscribe((r:any) => {
			 console.log("DossierPeronneComponent form cloased",r)
      		if(r){
				
				 this.changed.emit(r); 
			}
			
			
		});
		}
		
	}

    setObjectUserRights(obj: any | any[], type: string) {
        if(this.user != undefined){
            if (Array.isArray(obj)) {
                obj.forEach((item: any) => {
                    item = this.applyRightsObj(item, type);
                });
            } else {
                obj = this.applyRightsObj(obj, type);
            }
        }
        return obj;
    }
    
    applyRightsObj(obj: any, type: string) {
        let rg: any = {
            r: true,
            w: true,
            x: true
        };
        let key = null;
        switch (type) {
            case "formulaire":
                if (obj.form!=undefined )
                	key = obj.form.key;
                break;
        }
    
        if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
            if (this.user.droitsObjets[type][key] != undefined) {
                rg = this.user.droitsObjets[type][key];
            }
        }
    
        obj.rights = rg;
    
        if (obj.isEditable || obj.isEditable==undefined) {
            obj.isEditable = rg.w;
        }
        return obj;
    }

}
